import { useAuth } from "@/store/auth";
import { ManagementPrivate } from "@busy-human/k9-library";
import { GoogleAuthProvider } from "firebase/auth";
import { onSnapshot } from 'firebase/firestore'
import { unlinkGoogle } from "./functions";

const CLIENT_ID = CONFIG.google.clientId;
const SCOPES = [
    "https://www.googleapis.com/auth/calendar",
    //"https://www.googleapis.com/auth/calendar.events",
    "https://www.googleapis.com/auth/userinfo.email",
    //"https://www.googleapis.com/auth/calendar.app.created", // There's a good chance this scope doesn't work
    //"https://www.googleapis.com/auth/calendar.calendarlist.readonly",
]
const TOKEN_LENGTH = 32;

const googleProvider = new GoogleAuthProvider();
for(const scope of SCOPES) {
    googleProvider.addScope(scope);
}

function makeID(length: number) {
    const vals: string[] = [];
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for(let i = 0; i < length; i++) {
        const x = Math.floor(Math.random() * chars.length);
        vals.push(chars[x]);
    }
    return vals.join('');
} 

const api = {
    linkGoogle: async (popupInstance: Window | null) => {
        const uid = useAuth().currentUid;
        if(!uid) throw new Error("Not logged in");

        const docEnt = ManagementPrivate.Collection.docEntity(uid);
        const docRef = ManagementPrivate.Collection.docRef(uid);

        const token = makeID(TOKEN_LENGTH);

        const privData = ManagementPrivate.Default();
        privData.stateToken = token;

        await docEnt.set(privData);

        const state = btoa(JSON.stringify({ token, uid }));

        const url = new URL("https://accounts.google.com/o/oauth2/v2/auth")
        const params: Record<string, string> = {
            state,
            access_type: 'offline',
            scope: SCOPES.join(' '),
            prompt: 'consent',
            response_type: 'code',
            client_id: CLIENT_ID,
            redirect_uri: `https://us-central1-${CONFIG.firebase.config.projectId}.cloudfunctions.net/finishGoogleSetup`
        }
        for(const p in params) {
            url.searchParams.set(p, params[p]);
        }

        if(!popupInstance) throw new Error("Popup failed");

        popupInstance.location.href = url.toString();

        let resolve: () => void
        let reject: (error: any) => void

        const promise = new Promise<void>((res, rej) => {
            resolve = res;
            reject = rej;
        })

        const popupClosed = setInterval(function() {
            if(popupInstance.closed) {
                clearInterval(popupClosed);
                reject("Popup closed by user");
            }
        }, 250);

        const unsub = onSnapshot(docRef, next => {
            const data = next.data();
            if(!data) return;
            if(data.refreshToken !== '') resolve();
            if(typeof data.error !== 'undefined') reject(data.error);
        });

        let timeout = setTimeout(() => reject("Request timed out"), 5 * 60 * 1000);

        try {
            await promise;
        } catch (e) {
            console.error(e);
            await api.unlinkGoogle();
            throw e;
        } finally {
            unsub();
            clearTimeout(timeout);
        }

    },
    unlinkGoogle: async () => {
        const uid = useAuth().currentUid;
        if(!uid) throw new Error("Not logged in");
        const res = await unlinkGoogle({uid});
        console.log("Unlinked Google:", res);
    }
}

export default api;